// @ts-nocheck

import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useMergeProps from '../../../hooks/useMergeProps';
import { resetPanelContent as resetPanelContentAction } from '../actions/immersive';
import ImmersivePlayer from '../ImmersivePlayer';
import { immersiveSelector } from '../selectors/immersive';

type ImmersivePlayerContainerProps = {
  className?: string;
  fetchUrl: string;
  fetchConfig: unknown;
  isHighlight: boolean;
  matchId: number;
};

const ImmersivePlayerContainer = (ownProps: ImmersivePlayerContainerProps) => {
  const { matchId } = ownProps;
  const dispatch = useDispatch();

  const selectorProps = useMemo(() => ({ matchId }), [matchId]);
  const selectedProps = useSelector((state) => immersiveSelector(state, selectorProps));

  const resetPanelContent = useCallback(() => {
    dispatch(resetPanelContentAction());
  }, [dispatch]);

  const otherProps = useMemo(
    () => ({
      resetPanelContent,
    }),
    [resetPanelContent],
  );

  const enhancedProps = useMergeProps({ ownProps, selectedProps, otherProps });

  return <ImmersivePlayer {...enhancedProps} />;
};

export default ImmersivePlayerContainer;
